import script from "./OverviewMarkets.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewMarkets.vue?vue&type=script&setup=true&lang=js"

import "./OverviewMarkets.vue?vue&type=style&index=0&id=7e94dca1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e94dca1"]])

export default __exports__